import { render } from "./student_register_confirm.vue?vue&type=template&id=227156fe&scoped=true"
import script from "./student_register_confirm.vue?vue&type=script&lang=js"
export * from "./student_register_confirm.vue?vue&type=script&lang=js"

import "./student_register_confirm.vue?vue&type=style&index=0&id=227156fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227156fe"]])

export default __exports__